var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 12,
    viewBox: "0 0 80 12",
    fill: "#1BBC34",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#1BBC34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.77344L10 -6.51919e-05V11.5469L0 5.77344ZM80 5.77344V6.77344H9V5.77344V4.77344H80V5.77344Z",
    fill: "#1BBC34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGreen);
export default __webpack_public_path__ + "static/media/arrow-left-green.066ae8d131d8696ac9164e4b2a72033c.svg";
export { ForwardRef as ReactComponent };